import formValidator, {
	required,
	isCorrectEmailLen,
	isEmail,
	and,
} from "@insightfulscience/shared-utils/validation";
import parseNumber from "@insightfulscience/shared-utils/parsers/parseNumber";

export const initialState = {
	email: "",
	firstName: "",
	lastName: "",
	company: "",
	countryID: 0,
	state: "",
	productOfInterest: "",
	message: "",
};

export const productOfInterest = [
	{ text: "PRODUCT_OF_INTEREST_OPTION.GENEIOUS_PRIME", value: "geneious_prime" },
	{ text: "PRODUCT_OF_INTEREST_OPTION.GENEIOUS_BIOLOGICS", value: "geneious_biologics" },
];

const schema = {
	email: [
		[required, "errors.EMAIL_REQUIRED"],
		[email => isEmail(email), "errors.EMAIL_INVALID"],
		[isCorrectEmailLen(64), "errors.EMAIL_INVALID_LENGTH"],
	],
	firstName: [required, "errors.FIRST_NAME_REQUIRED"],
	lastName: [required, "errors.LAST_NAME_REQUIRED"],
	countryID: [and(required, value => parseNumber(value, 0) > 0), "errors.COUNTRY_REQUIRED"],
	state: [
		(state, { countryID }) => ![220, 38].includes(parseNumber(countryID, 0)) || required(state), // state is required only if country = US or Canada
		"errors.STATE_REQUIRED",
	],
	company: [required, "errors.COMPANY_REQUIRED"],
	productOfInterest: [required, "errors.PRODUCT_OF_INTEREST_REQUIRED"],
	message: [required, "errors.MESSAGE_REQUIRED"],
};

export const validateForm = formValidator(schema);
